












































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaFullDialog from "@/Ui-Components/Common/Container/ParticaFullDialog.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaBaseView from "../../Base/ParticaBaseView.vue";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import { ParticaDropEvent, eParticaDragType, ParticaItem, ParticaSubItem } from "../../../Models/ParticaItem";
import { IViewerArticleService, ViewerArticleService } from "../../../BusinessServices/viewerarticles";
import { ViewerContentService } from "../../../BusinessServices/viewercontent";
import { MyGroupingOfArticlePropDTO, IIssueModel, IssueModel } from "../../../Generated/ParticaAPI";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import ParticaArticleEdit from "@/Ui-Components/Article/Edit/ParticaArticleEdit.vue";
import { Article, IArticle, IExtractedArticle } from "../../../Models/ArticleModels/article";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";
import { ParticaConfirmConfig } from "../../../Models/Components.model";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { IIssueService } from "../../../BusinessServices/issue";
import SectionManager from "@/Views/Domain/Title/SectionManager.vue";
import ManageArticles from "@/Ui-Components/Article/ManageArticles.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";

@Component(
	{
		name: "IssueManageArticles",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaFullDialog,
			ManageArticles,
			ParticaArticleEdit,
			ParticaArticlePreview,
			ParticaConfirmDialog,
			ButtonList,
			SectionManager,
			ParticaCard,
			ParticaView
		}
	})
export default class IssueManageArticles extends ParticaIssueBase {
	@Prop() private id: number;
	private viewerArticleService: IViewerArticleService;
	private issueService: IIssueService;
	private articles: ParticaItem[] = [];
	private issue: IssueModel = new IssueModel();
	private showsectionmanager: boolean = false;

	private buttons: ButtonConfig[] = [
		{
			label: "Section Manager",
			action: eParticaAction.PUBLICATION_SECTION_MANAGER,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Publish Viewer Articles",
			action: eParticaAction.PUBLISH_VIEWER_ARTICLES,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Extract Articles",
			action: eParticaAction.ISSUE_EXTRACT,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private previewarticle: IExtractedArticle = new Article() as IExtractedArticle;
	private showpreview: boolean = false;
	private previewbuttons: ButtonConfig[] = [
	];

	private editarticle: IExtractedArticle = new Article() as IExtractedArticle;
	private showedit: boolean = false;
	private editbuttons: ButtonConfig[] = [
		{
			label: "Save Article",
			action: eParticaAction.ARTICLE_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	@Watch("showsectionmanager")
	private async reloadsections() {
		if (this.showsectionmanager === false) {
			await this.init();
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ARTICLE_SAVE: {
					this.editarticle.issueId = this.id;
					this.editarticle = await this.viewerArticleService.saveArticle(this.editarticle);
					break;
				}
				case eParticaAction.PROPERTY_CHANGED: {
					break;
				}
				case eParticaAction.ISSUE_EXTRACT: {
					this.navigate("issueextraction", { id: this.id.toString() });
					break;
				}
				case eParticaAction.RIGHT_MOUSE_CLICK:
				case eParticaAction.ARTICLE_EDIT: {
					this.editarticle = await this.viewerArticleService.getArticle(this.id, event.item.id as string);
					this.showedit = true;
					break;
				}
				case eParticaAction.ARTICLE_DELETE_REQUEST: {
					this.dialog.title = "Confirm deletion of article.";
					this.dialog.message = `You have requested that article '${event.item.name}' be deleted.`;
					this.dialog.action = eParticaAction.ARTICLE_DELETE;
					this.dialog.show = true;
					break;
				}
				case eParticaAction.ARTICLE_DELETE: {
					this.dialog.show = false;
					this.ShowSnackbar("do delete");
					break;
				}
				case eParticaAction.PUBLICATION_SECTION_MANAGER: {
					this.showsectionmanager = true;
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					this.previewarticle = await this.viewerArticleService.getArticle(this.id, event.item.id as string);
					this.showpreview = true;
					break;
				}
				case eParticaAction.DRAG_MOVE_REQUEST: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.title = "Confirm moving article.";
							this.dialog.message = `Move article '${movedata.source.name}' to section '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.many: {
							this.dialog.title = "Confirm moving articles.";
							this.dialog.message = `Move all articles from section '${movedata.source.name}' to section '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.all: {
							// check issue is not dropped on itself.
							// confirm you want to move all articles in issue to new issue.
							// if different pub then sections will be created if they do not exist.
							this.ShowSnackbar(`not implemented`);
							break;
						}
					}
					break;
				}
				case eParticaAction.DRAG_MOVE: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.show = false;
							await this.viewerArticleService.moveArticle(movedata.source.id, parseInt(movedata.destination.id, 0), this.id);
							await this.init();
							break;
						}
						case eParticaDragType.many: {
							this.dialog.show = false;
							// i need to handle the case where source.sectionid is not available on this page. (moving between pubs)
							// e.g. moveAllSectionToNewSection(source.sectionId, dest.sectionId)
							const section: ParticaItem | undefined = this.articles.find(a => a.id === movedata.source.id);
							if (section !== undefined) {
								const articleIds: string[] = section.items.map(i => i.id);
								await this.viewerArticleService.moveArticles(articleIds, parseInt(movedata.destination.id, 0), this.id);
							}
							await this.init();
							break;
						}
						case eParticaDragType.all: {
							// this.ShowSnackbar(`confirm move many ${movedata.source.name} to ${movedata.destination.name}`)
							break;
						}
					}
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Manage Articles";
		this.viewerArticleService = this.particaServices.getViewerArticleService();
		this.issueService = this.particaServices.getIssueService();
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			// get articles by section
			this.articles = await this.viewerArticleService.getArticlesBySection(this.id);
			this.issue = await this.issueService.getIssue(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}


}
